import React, { Component, PropTypes }  from 'react';
import Button                           from '../Button';
import './style.scss';

export class FileInput extends Component {
    static propTypes = {
        file: PropTypes.object,
        buttonText: PropTypes.node,
        onChange: PropTypes.func
    };

    state = {
        file: null
    };

    handleOnClick = (e) => {
        e.preventDefault();
        this.fileInputEl.value = null;
        this.fileInputEl.click();
    };

    handleChange = (e) => {
        e.preventDefault();

        const uploadedFile = e.dataTransfer ? e.dataTransfer.files[0] : e.target.files[0];
        const isImage = uploadedFile.type.includes('image');

        uploadedFile.preview = isImage ? window.URL.createObjectURL(uploadedFile) : null;

        // this.setState({
        //     file: uploadedFile
        // });

        if (this.props.onChange) {
            this.props.onChange(uploadedFile);
        }
    };

    render () {
        const { buttonText, onChange, file, ...other } = this.props;
        const inputAttributes = {
            accept: '*',
            type: 'file',
            style: { display: 'none' },
            ref: el => this.fileInputEl = el,
            onChange: this.handleChange
        };

        return (
            <div className="fi__inputContainer" {...other}>
                {buttonText && !file ?
                    <Button className="fi__btn" icon="attach_file" primary onClick={this.handleOnClick} flat>{buttonText}</Button>
                    :
                    <Button className="fi__btn" icon="attach_file" primary onClick={this.handleOnClick} flat />
                }
                <input {...inputAttributes} />
                {file && file.preview ?
                    <img className="fi__preview" src={file.preview} />
                    :
                    file &&
                    <span className="fi__previewName">{file.name}</span>}
            </div>
        );
    }
}

export default FileInput;
